import { useState } from 'react';
import { Input, Modal } from 'antd';

interface NamePromptModalProps {
  open: boolean;
  title: string;
  label?: string;
  initialValue?: string;
  confirmLoading?: boolean;
  onSubmit: (value: string) => void;
  onCancel: () => void;
}

export const NamePromptModal = ({
  open,
  title,
  label = 'Name',
  initialValue = '',
  confirmLoading,
  onSubmit,
  onCancel,
}: NamePromptModalProps) => {
  const [value, setValue] = useState(initialValue);
  // Reset the field to `initialValue` on the closed→open transition (not
  // continuously, so typing isn't clobbered while the modal stays open).
  const [wasOpen, setWasOpen] = useState(open);
  if (open !== wasOpen) {
    setWasOpen(open);
    if (open) {
      setValue(initialValue);
    }
  }

  const trimmed = value.trim();

  return (
    <Modal
      open={open}
      title={title}
      onCancel={onCancel}
      onOk={() => trimmed && onSubmit(trimmed)}
      okButtonProps={{ disabled: !trimmed, loading: confirmLoading }}
      destroyOnHidden
    >
      <div className="flex flex-col gap-1">
        <label className="text-xs text-gray-500">{label}</label>
        <Input
          autoFocus
          value={value}
          onChange={(event) => setValue(event.target.value)}
          onPressEnter={() => trimmed && onSubmit(trimmed)}
        />
      </div>
    </Modal>
  );
};
